/*
 * @Author: zhiqiqi
 * @Date: 2022-11-30 16:33:40
 * @LastEditTime: 2022-12-21 11:13:34
 * @LastEditors: zhiqiqi
 * @Description: 
 */
import 'babel-polyfill'
import { hot } from 'react-hot-loader/root'
import { loadClient } from '@ke/loreux'
import 'styles/index.css'
import routers from './routers'

//引入antd样式文件
import 'antd-mobile/lib/button/style/css'
import 'antd-mobile/lib/toast/style/css'
import 'antd-mobile/lib/modal/style/css'
import 'antd-mobile/lib/icon/style/css'
import 'antd-mobile/lib/progress/style/css'
import 'antd-mobile/lib/input-item/style/css'

function routerUpdate(to) {
  // 此处可以处理SPA跳转时page页面路由变更时的逻辑，一般用于更换埋点uicode
  console.log(`页面uicode：${to.meta.uicode}`)

  const title = (to.meta && to.meta.title) || ''
  document.title = title
}

loadClient('root', {
  routers,
  routerUpdate,
  appWrapper: App => {
    const hotApp = hot(App)
    return hotApp
  },
})
